"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioRecorder = void 0;
var vue_1 = require("@formily/vue");
var reactive_vue_1 = require("@formily/reactive-vue");
var composition_api_1 = require("@vue/composition-api");
// @ts-ignore
var recordingButton_vue_1 = __importDefault(require("./recordingButton.vue"));
exports.AudioRecorder = (0, reactive_vue_1.observer)((0, composition_api_1.defineComponent)({
    name: 'FAudioRecorder',
    props: [
        'value',
        'minDuration',
        'maxDuration',
        'bitRate',
        'sampleRate',
        'disabled',
        'readOnly',
        'onChange',
        'onStart',
        'onComplete',
        'onConfirm',
        'onDiscard',
        'onError',
    ],
    setup: function (props, _a) {
        var attrs = _a.attrs, listeners = _a.listeners;
        var formRef = (0, vue_1.useParentForm)();
        return function () {
            var _a = props.value, value = _a === void 0 ? { url: '', info: '' } : _a, _b = props.minDuration, minDuration = _b === void 0 ? 1 : _b, _c = props.maxDuration, maxDuration = _c === void 0 ? 60 : _c, _d = props.bitRate, bitRate = _d === void 0 ? 128 : _d, _e = props.sampleRate, sampleRate = _e === void 0 ? 44100 : _e, disabled = props.disabled, readOnly = props.readOnly, _f = props.onChange, onChange = _f === void 0 ? listeners === null || listeners === void 0 ? void 0 : listeners.change : _f, _g = props.onStart, onStart = _g === void 0 ? listeners === null || listeners === void 0 ? void 0 : listeners.start : _g, _h = props.onComplete, onComplete = _h === void 0 ? listeners === null || listeners === void 0 ? void 0 : listeners.complete : _h, _j = props.onConfirm, onConfirm = _j === void 0 ? listeners === null || listeners === void 0 ? void 0 : listeners.confirm : _j, _k = props.onDiscard, onDiscard = _k === void 0 ? listeners === null || listeners === void 0 ? void 0 : listeners.discard : _k, _l = props.onError, onError = _l === void 0 ? listeners === null || listeners === void 0 ? void 0 : listeners.error : _l;
            var form = formRef === null || formRef === void 0 ? void 0 : formRef.value;
            // 表单提交中时禁用录音
            var isFormSubmitting = !!(form === null || form === void 0 ? void 0 : form.submitting);
            var children = {
                default: function () { return []; },
            };
            return (0, vue_1.h)(recordingButton_vue_1.default, {
                attrs: __assign(__assign({}, attrs), { 
                    // Formily 字段值（受控）
                    value: value, minDuration: minDuration, maxDuration: maxDuration, bitRate: bitRate, sampleRate: sampleRate, disabled: disabled || isFormSubmitting, readOnly: readOnly }),
                on: __assign(__assign({}, listeners), { 
                    // v-model 同步：vue 文件里 emit('input', data)
                    input: function (val) {
                        if (onChange) {
                            if (onChange(val) === false)
                                return;
                        }
                    }, 
                    // 录音事件透传
                    start: function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        if (onStart)
                            onStart.apply(void 0, args);
                    }, complete: function (record) {
                        if (onComplete)
                            onComplete(record);
                    }, confirm: function (data) {
                        if (onConfirm)
                            onConfirm(data);
                    }, discard: function (info) {
                        if (onDiscard)
                            onDiscard(info);
                    }, error: function (err) {
                        if (onError)
                            onError(err);
                    } }),
            }, children);
        };
    },
}));
exports.default = exports.AudioRecorder;
